import actions from './actionTypes';
export default function (resourceType, initialState, state, action) {
    const types = actions(resourceType);
    switch(action.type) {
        case types.load:
            return Object.assign({}, {
                ...state,
                loading: action.payload.loading
            });

        case types.hydrate:
            return {
                init: true,
                error: action.payload.error || false,
                loading: false,
                data: action.payload.data
            };

        case types.add:
            return {
                ...state, 
                data: {
                    ...state.data,
                    ...action.payload.data
                }
            }

        case types.remove:
            let data = {...state.data};
            try{
                delete data[action.payload.id];
            }catch(e){}
            return {
                ...state, 
                data
            }

        case types.update:
            return {
                ...state, 
                data: {
                    ...state.data,
                    ...action.payload.data
                }
            }

        case types.set:
            return {
                ...state, 
                ...action.payload
            };

        case types.reset:
            return {...initialState};

        case 'shapes.reset': 
            return {...initialState};

        default:
            return state
    }
}